const API_BASE = '/api';

export const pdfService = {
    // Gerar relatório de reservas
    async generateBookingsReport(startDate, endDate) {
        const token = localStorage.getItem('token');
        const response = await fetch(
            `${API_BASE}/pdf/bookings?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }
        );
        
        if (!response.ok) {
            throw new Error('Erro ao gerar relatório');
        }
        
        return response.blob();
    },

    // Gerar relatório de utilizador
    async generateUserReport(userId) {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE}/pdf/user/${userId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (!response.ok) {
            throw new Error('Erro ao gerar relatório');
        }
        
        return response.blob();
    },

    // Gerar relatório de receitas
    async generateRevenueReport(startDate, endDate) {
        const token = localStorage.getItem('token');
        const response = await fetch(
            `${API_BASE}/pdf/revenue?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }
        );
        
        if (!response.ok) {
            throw new Error('Erro ao gerar relatório');
        }
        
        return response.blob();
    },

    // Gerar relatório de assiduidade
    async generateAttendanceReport(startDate, endDate) {
        const token = localStorage.getItem('token');
        const response = await fetch(
            `${API_BASE}/pdf/attendance?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }
        );
        
        if (!response.ok) {
            throw new Error('Erro ao gerar relatório');
        }
        
        return response.blob();
    },

    // Gerar confirmação de reserva
    async generateBookingConfirmation(bookingId) {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE}/pdf/booking/${bookingId}/confirmation`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (!response.ok) {
            throw new Error('Erro ao gerar confirmação');
        }
        
        return response.blob();
    },

    // Gerar fatura
    async generateInvoice(transactionId) {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE}/pdf/invoice/${transactionId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (!response.ok) {
            throw new Error('Erro ao gerar fatura');
        }
        
        return response.blob();
    },

    // Gerar leaderboard
    async generateLeaderboard() {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE}/pdf/leaderboard`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (!response.ok) {
            throw new Error('Erro ao gerar leaderboard');
        }
        
        return response.blob();
    },

    // Gerar horário semanal
    async generateSchedule(weekStart) {
        const token = localStorage.getItem('token');
        const response = await fetch(
            `${API_BASE}/pdf/schedule?weekStart=${weekStart.toISOString()}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }
        );
        
        if (!response.ok) {
            throw new Error('Erro ao gerar horário');
        }
        
        return response.blob();
    },

    // Utility: Download blob as file
    downloadBlob(blob, filename) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    },

    // Utility: Open blob in new tab
    openBlob(blob) {
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
    }
};

export default pdfService;
